import { memo } from 'react';

import { useAddToCartHandle } from '@/screens/Cart/hooks/useAddToCartHandle';

import { ProductCardType } from '@shared/types/product';
import { Button } from '@shared/ui/Button';
import { HStack } from '@shared/ui/Stack';
import { ComparisonButton } from '@widgets/ProductCard/ui/ComparisonButton/ComparisonButton';
import { FavoriteButton } from '@widgets/ProductCard/ui/FavoriteButton/FavoriteButton';

import cls from './Bot.module.scss';

type BotProps = ProductCardType & {
  comparisonPage?: boolean;
};

export const Bot = memo<BotProps>((props) => {
  const { productInCart, handleClickAddToCart } = useAddToCartHandle(props);

  const inStock = props?.remainder !== undefined && +props?.remainder !== 0;
  const cartButtonLabel = !inStock ? 'Нет в наличии' : productInCart ? 'Перейти в корзину' : 'Добавить в корзину';

  return (
    <HStack className={cls.wrap}>
      <Button
        disabled={!inStock}
        aria-label={cartButtonLabel}
        fullWidth
        size={'m'}
        className={cls.button}
        onClick={handleClickAddToCart}
        variant={productInCart ? 'tertiary' : 'accent'}
      >
        {cartButtonLabel}
      </Button>
      <ComparisonButton
        id={props.id}
        category={props.category}
      />
      <FavoriteButton productId={props.id} />
    </HStack>
  );
});
